/******/ (() => {
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {
      if (window.PXUTheme.getSectionData) {
        window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));
      }
      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");
        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();
          return false;
        });

        if (!$("body").hasClass("atc-user-activate") && !$("body").hasClass("atc-user-activatev2")) {
          const rewardSections = document.querySelectorAll(".discount-reward-bar");
          rewardSections.forEach((rewardSection) => {
            rewardSection.style.display = "none";
          });

          const drawerSections = document.querySelectorAll(".custom-cart-rewards-bar");
          drawerSections.forEach((drawerSection) => {
            drawerSection.style.display = "none";
          });
          const cartWrapers = document.querySelectorAll(".theme-ajax-cart");
          cartWrapers.forEach((cartWraper) => {
            if (cartWraper && !cartWraper.classList.contains("drawer-without-reward")) {
              cartWraper.classList.add("drawer-without-reward");
            }
          });
        } else {
          const cartContentWrappers = document.querySelectorAll(".ajax_cart_content");
          if (cartContentWrappers) {
            cartContentWrappers.forEach((cartContentWrapper) => {
              if (cartContentWrapper && !cartContentWrapper.classList.contains("is-atc-user")) {
                cartContentWrapper.classList.add("is-atc-user");
              }
            });
          }
        }
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      $(document).on("click", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);
        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();
        const lineID = $(this).parents("[data-line-item]").data("line-item");
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.removeFromCart(lineID);
        }
        return false;
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();
        return false;
      });
    },
    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");
      $el.hover(
        function () {
          if (window.PXUTheme.theme_settings.header_layout == "centered" && $(".header-sticky-wrapper").hasClass("is-sticky")) {
            $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass("show-mini-cart");
          } else {
            $el.addClass("show-mini-cart");
          }
        },
        function () {
          $el.removeClass("show-mini-cart");
        }
      );
    },
    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents("[data-ajax-cart-trigger]");
      $el.removeClass("show-mini-cart");
    },
    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");
      $el.attr("href", "#");
      $el.off("touchstart").on("touchstart", function (e) {
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }
        $el.toggleClass("show-mini-cart");
      });
    },
    showDrawer: function () {
      if (!document.body.classList.contains("atc-user-activate") && !document.body.classList.contains("atc-user-activatev2")) {
        window.location.href = document.location.origin + window.Shopify?.routes?.root + "cart/";
        return false;
      }
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");
      $("html").addClass("cart_popup_visible");
      var $lightbox = $(".quick-shop__lightbox");
      if ($lightbox.hasClass("fancybox-is-open")) {
        $lightbox.removeClass("fancybox-is-open");
        $lightbox.find(".quick-shop__popup").css("display", "");
        var flickityInstance = $lightbox.flickity();
        flickityInstance.resize();
      }
    },
    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");
      $("html").removeClass("cart_popup_visible");
    },
    removeFromCart: function (lineID, callback) {
      $(".ajax_cart_content").addClass("cart-loading");
      const root = window.Shopify?.routes?.root || '/';
      $.ajax({
        type: "POST",
        url: `${root}cart/change.js`,
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: async function (cart) {
          await window.PXUTheme.jsAjaxCart.updateGiftProducts();
          window.PXUTheme.jsAjaxCart.updateView();
        },
        error: function (XMLHttpRequest, textStatus) {
          $(".ajax_cart_content").removeClass("cart-loading");
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
        },
      });
    },
    initializeAjaxCart: function () {
      window.PXUTheme.asyncView
        .load(window.PXUTheme.routes.cart_url, "ajax")
        .done(({ html, options }) => {
          $("[data-ajax-cart-content]").html(html.content);

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
          if (crossSellBlock && crossSellBlock.products && crossSellBlock.products.length > 0) {
            const crossSellProducts = crossSellBlock.products;
            renderCrossSellProductElement(crossSellProducts);
          }
          initUpsellCheckbox();
          window.PXUTheme.jsAjaxCart.updateView();
        });
    },
    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();
      window.PXUTheme.asyncView
        .load(window.PXUTheme.routes.cart_url, "ajax")
        .done(({ html, options }) => {
          $(".mobile-header [data-ajax-cart-content]").html(html.content);
        });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");
      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;
        $(".warning").remove();
        $addToCartForm.addClass("shopify-product-form--unselected-error").find(".cart-warning").html(cartWarning);
        $addToCartBtn.removeAttr("disabled").removeClass("disabled");
        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");
        $addToCartBtn.find("span:not(.icon)").text($addToCartBtn.data("label")).removeClass("zoomOut").addClass("zoomIn");
      } else {
        const root = window.Shopify?.routes?.root || '/';
        $(".ajax_cart_content").addClass("cart-loading");
        $.ajax({
          url: `${root}cart/add.js`,
          dataType: "json",
          cache: false,
          type: "post",
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
            $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut");
          },
          success: function (product) {
            let $el = $("[data-ajax-cart-trigger]");
            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $(".mobile-header [data-ajax-cart-trigger]");
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }
              $el.addClass("show-mini-cart");
              $addToCartBtn.find("span").removeClass("fadeInDown");
            }

            window.PXUTheme.jsAjaxCart.updateGiftProducts().then(() => {
              window.PXUTheme.jsAjaxCart.updateView();
              window.setTimeout(function () {
                $addToCartBtn.removeAttr("disabled").removeClass("disabled");
                $addToCartBtn.find(".checkmark").removeClass("checkmark-active");
                $addToCartBtn.find(".text, .icon").removeClass("zoomOut").addClass("fadeInDown");
                $addToCartBtn.on("webkitAnimationEnd oanimationend msAnimationEnd animationend", addedToCart);
              }, 1000);
              window.PXUTheme.jsAjaxCart.showDrawer();
            });
          },
          error: function (XMLHttpRequest) {
            $(".ajax_cart_content").removeClass("cart-loading");
            let response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace("All 1 ", "All ")}</p>`;
            $(".warning").remove();
            $addToCartForm.find(".cart-warning").html(cartWarning);
            $addToCartBtn.removeAttr("disabled").removeClass("disabled");
            $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");
            $addToCartBtn.find("span:not(.icon)").text($addToCartBtn.data("label")).removeClass("zoomOut").addClass("zoomIn");
          },
        });
      }
    },
    updateView: function () {
      window.PXUTheme.asyncView
        .load(window.PXUTheme.routes.cart_url, "ajax")
        .done(({ html, options }) => {
          if (options.item_count > 0) {
            const itemList = $(html.content).find(".ajax-cart__list");
            const cartDetails = $(html.content).find(".ajax-cart__details-wrapper");
            const drawerSections1 = document.querySelectorAll(".custom-cart-drawer1");
            const rewardSections1 = document.querySelectorAll(".discount-reward-bar");
            $(".ajax-cart__list").replaceWith(itemList);
            $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
            $(".ajax-cart__empty-cart-message").addClass("is-hidden");
            $(".ajax-cart__form").removeClass("is-hidden");
            $("[data-ajax-cart-trigger]").addClass("has-cart-count");
            $("[data-bind='itemCount']").text(options.item_count);
            $(".cart_drawer_total_product").text("(" + options.item_count + ")");
            if (rewardSections1) {
              rewardSections1.forEach((rewardSection) => {
                if (rewardSection.classList.contains("hide")) {
                  rewardSection.classList.remove("hide");
                }
              });
            }
            if (drawerSections1) {
              drawerSections1.forEach((drawerSection) => {
                if (drawerSection.classList.contains("hide")) {
                  drawerSection.classList.remove("hide");
                }
              });
            }
          } else {
            $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
            $(".ajax-cart__form").addClass("is-hidden");
            $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
            $("[data-bind='itemCount']").text("0");
            $(".cart_drawer_total_product").text("(0)");
            const drawerSections1 = document.querySelectorAll(".custom-cart-drawer1");
            const rewardSections1 = document.querySelectorAll(".discount-reward-bar");
            if (rewardSections1) {
              rewardSections1.forEach((rewardSection) => {
                if (!rewardSection.classList.contains("hide")) {
                  rewardSection.classList.add("hide");
                }
              });
            }
            if (drawerSections1) {
              drawerSections1.forEach((drawerSection) => {
                if (!drawerSection.classList.contains("hide")) {
                  drawerSection.classList.add("hide");
                }
              });
            }
          }

          updateMultiRewardsBar();

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
          initOrReinitCrossSellSliders();
          initUpsellCheckbox();
          $(".ajax_cart_content").removeClass("cart-loading");
        })
        .fail(() => {
          $(".ajax_cart_content").removeClass("cart-loading");
        });
    },
    updateGiftProducts: async function () {
      console.log("[GIFT] updateGiftProducts started");
      $(".ajax_cart_content").addClass("cart-loading");

      try {
        await new Promise((r) => setTimeout(r, 400));
        const root = window.Shopify?.routes?.root || '/';
        const cartResponse = await fetch(`${root}cart.js`, { cache: 'no-store' });
        const cart = await cartResponse.json();

        console.log("[GIFT] Cart items:", cart.items.map(i => ({ title: i.title, variant_id: i.variant_id, final_price: i.final_price, final_line_price: i.final_line_price, properties: i.properties })));

        let cartTotal = 0;
        cart.items.forEach((item) => {
          var isGift = (item.properties && item.properties['Rewards'] === 'Free Gift') ||
            (item.properties && item.properties['_gift'] === 'true') ||
            (Number(item.final_price) === 0) ||
            (item.url && item.url.indexOf('gratis') > -1);
          if (!isGift) {
            cartTotal += Number(item.final_line_price);
          } else {
            console.log("[GIFT] Skipping gift item:", item.title, item.variant_id);
          }
        });

        if (cartTotal === 0 && cart.total_price > 0) {
          console.log("[GIFT] cartTotal was 0, falling back to cart.total_price:", cart.total_price);
          cartTotal = cart.total_price;
        }

        cartTotal = cartTotal / 100;
        const items = cart.items;
        const cartCurrency = cart.currency;

        const isATCUserV2 = $("body").hasClass("atc-user-activatev2");
        const isATCUser = isATCUserV2 ? false : $("body").hasClass("atc-user-activate");

        console.log("[GIFT] cartTotal:", cartTotal, "currency:", cartCurrency);
        console.log("[GIFT] isATCUser:", isATCUser, "isATCUserV2:", isATCUserV2);

        let MILESTONE_1, MILESTONE_2;
        if(isATCUserV2){
          if (cartCurrency === "MXN") {
            MILESTONE_1 = 784;
            MILESTONE_2 = 1393;
          } else {
            MILESTONE_1 = 39.42;
            MILESTONE_2 = 69.99;
          }
        }else{
          if (cartCurrency === "MXN") {
            MILESTONE_1 = 780;
            MILESTONE_2 = 1447;
          } else {
            MILESTONE_1 = 37.42;
            MILESTONE_2 = 69.90;
          }
        }
        

        console.log("[GIFT] Milestones:", MILESTONE_1, MILESTONE_2);

        const GIFT_ATC_37 = 51953730847059;
        const GIFT_ATC_70 = 51953725145427;
        const GIFT_ATC2_37 = 54316563792211;
        const GIFT_ATC2_70 = 51953725145427;

        let targetGiftVariantId = null;

        /*
        if (isATCUserV2 || (!isATCUser && !isATCUserV2)) {
          if (cartTotal >= MILESTONE_2) {
            targetGiftVariantId = GIFT_ATC2_70;
          } else if (cartTotal >= MILESTONE_1) {
            targetGiftVariantId = GIFT_ATC2_37;
          }
        } else {
          if (cartTotal >= MILESTONE_2) {
            targetGiftVariantId = GIFT_ATC_70;
          } else if (cartTotal >= MILESTONE_1) {
            targetGiftVariantId = GIFT_ATC_37;
          }
        }*/

            if (isATCUser) {
          if (cartTotal >= MILESTONE_2) {
            targetGiftVariantId = GIFT_ATC_70;
          } else if (cartTotal >= MILESTONE_1) {
            targetGiftVariantId = GIFT_ATC_37;
          }
        } else if (isATCUserV2) {
          if (cartTotal >= MILESTONE_2) {
            targetGiftVariantId = GIFT_ATC2_70;
          } else if (cartTotal >= MILESTONE_1) {
            targetGiftVariantId = GIFT_ATC2_37;
          }
        }

        console.log("[GIFT] targetGiftVariantId:", targetGiftVariantId);

        const FREE_GIFT_IDS = [GIFT_ATC_37, GIFT_ATC_70, GIFT_ATC2_37, GIFT_ATC2_70];
        const currentFreeGifts = items.filter((item) => item.properties?.Rewards === "Free Gift" || FREE_GIFT_IDS.includes(Number(item.variant_id)));
        console.log("[GIFT] currentFreeGifts in cart:", currentFreeGifts.map(i => i.variant_id));

        const removePromises = currentFreeGifts
          .filter((item) => Number(item.variant_id) !== Number(targetGiftVariantId))
          .map((item) => {
            console.log("[GIFT] Removing wrong gift:", item.variant_id);
            return fetch(`${root}cart/change.js`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            });
          });

        if (removePromises.length) {
          await Promise.all(removePromises);
          await new Promise((r) => setTimeout(r, 400));
        }

        const freshCartResp = await fetch(`${root}cart.js`, { cache: 'no-store' });
        const freshCart = await freshCartResp.json();
        const alreadyHasGift = freshCart.items.some((item) => Number(item.variant_id) === Number(targetGiftVariantId));

        console.log("[GIFT] alreadyHasGift:", alreadyHasGift, "targetGiftVariantId:", targetGiftVariantId);

        if (targetGiftVariantId && !alreadyHasGift) {
          console.log("[GIFT] Adding free gift:", targetGiftVariantId);
          const addPayload = {
            items: [{ id: targetGiftVariantId, quantity: 1, properties: { Rewards: "Free Gift" } }],
          };
          const addResp = await fetch(`${root}cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(addPayload),
          });
          const addResult = await addResp.json();
          console.log("[GIFT] cart/add.js result:", addResp.status, addResult);
          await new Promise((r) => setTimeout(r, 300));
        } else if (!targetGiftVariantId) {
          console.log("[GIFT] No gift target — cart total", cartTotal, "below milestone", MILESTONE_1);
        } else {
          console.log("[GIFT] Gift already in cart, nothing to do.");
        }
      } catch (err) {
        console.error("[GIFT] updateGiftProducts error:", err);
      }
    },
    unload: function ($section) {
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
    },
  };

  async function updateMultiRewardsBar() {
    const root = window.Shopify?.routes?.root || '/';
    try {
      const res = await fetch(`${root}cart.js`, { cache: 'no-store' });
      const cart = await res.json();
      const cartCurrency = cart.currency;
      const barContainer = $(".custom-cart-rewards-bar");
      const CurrencyIcon = barContainer.attr("data-currency") || "$";

      if (cart.item_count === 0) {
        barContainer.hide();
        return;
      }
      barContainer.show();

      let cleanCartTotal = 0;
      cart.items.forEach(function (item) {
        var isGift = (item.properties && item.properties['Rewards'] === 'Free Gift') ||
          (item.properties && item.properties['_gift'] === 'true') ||
          (Number(item.final_price) === 0) ||
          (item.url && item.url.indexOf('gratis') > -1);
        if (!isGift) {
          cleanCartTotal += Number(item.final_line_price);
        }
      });

      if (cleanCartTotal === 0 && cart.total_price > 0) {
        cleanCartTotal = cart.total_price;
      }

      cleanCartTotal = cleanCartTotal / 100;

const isATCUserV2 = $("body").hasClass("atc-user-activatev2");

      let milestone1, milestone2;
      if(isATCUserV2){
        if (cartCurrency === "MXN") {
          milestone1 = 784;
          milestone2 = 1393;
        } else {
          milestone1 = 39.42;
          milestone2 = 69.99;
        }
      }else{
        if (cartCurrency === "MXN") {
          milestone1 = 780;
          milestone2 = 1447;
        } else {
          milestone1 = 37.42;
          milestone2 = 69.90;
        }
      }  
      const m1_visual_percent = 60;
      const m2_visual_percent = 100;
      const tiers = [
        { amount: milestone1, label: milestone1 + " " + CurrencyIcon, reward: "Free Gift A", position: 40 },
        { amount: milestone2, label: milestone2 + " " + CurrencyIcon, reward: "Free Gift B", position: 0 },
      ];

      const messageEl = barContainer.find(".rewards-message");
      const tiersContainer = barContainer.find(".rewards-tiers");
      tiersContainer.empty();

      const progressBarHtml = `
        <div class="rewards-progress-bar" style="position: absolute; left: 0; right: 0; top: 12px; height: 3px; background: #d9d9d9; border-radius: 10px; z-index: 1; overflow: hidden; width: 100%;">
          <div class="rewards-progress-fill" style="width: 0%; height: 100%; background: #93e0d0; transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1); border-radius: 10px;"></div>
        </div>
      `;
      tiersContainer.append(progressBarHtml);
      const fill = tiersContainer.find(".rewards-progress-fill");

      let progressPercent = 0;
      const fillToBeforeDot1 = 48;
      const fillToBeforeDot2 = 88;

      if (cleanCartTotal < milestone1) {
        progressPercent = (cleanCartTotal / milestone1) * fillToBeforeDot1;
      } else if (cleanCartTotal >= milestone1 && cleanCartTotal < milestone2) {
        const rangeTotal = milestone2 - milestone1;
        const rangeCurrent = cleanCartTotal - milestone1;
        progressPercent = m1_visual_percent + (rangeCurrent / rangeTotal) * (fillToBeforeDot2 - m1_visual_percent);
      } else {
        progressPercent = m2_visual_percent;
      }

      fill.css("width", progressPercent + "%");

      let message = "";
      if (cleanCartTotal >= milestone2) {
        message = typeof RewardAfter !== 'undefined' ? `${RewardAfter}` : "¡RECOMPENSA APLICADA!";
      } else {
        const nextTarget = cleanCartTotal < milestone1 ? milestone1 : milestone2;
        const remaining = (nextTarget - cleanCartTotal).toFixed(2);
        message = typeof RewardText !== 'undefined' ? `${RewardText.replace("AMOUNT", remaining + " " + CurrencyIcon)}` : `SOLO TE FALTAN ${remaining} ${CurrencyIcon} PARA REGALO GRATIS`;
      }
      messageEl.html(message);
      let intensiveSizes = ["75ml", "200ml"];
      if(isATCUserV2){
        intensiveSizes = ["30ml", "200ml"];
      }
      tiers.forEach((tier, index) => {
        const isActive = cleanCartTotal >= tier.amount;
        const isLast = index === tiers.length - 1;
        const intensiveSize = intensiveSizes[index] || "75ml";

        const dot = `
        <div class="rewards-tiers-container rewards-tiers-container-no-icons ${isActive ? "active" : ""} ${isLast ? "last" : ""}" style="right:${tier.position}%; z-index: 2; position: absolute;">
          <div class="rewards-tiers-item-no-icon">
            <span class="icon" data-icon="gift">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="gift"><path d="M21.724 3.38302C22.2447 2.87233 23.0888 2.87233 23.6095 3.38302C24.1302 3.89371 24.1302 4.72151 23.6095 5.2322L8.94255 19.617C8.42184 20.1277 7.57781 20.1277 7.0571 19.617L0.390319 13.0784L0.299172 12.9788C-0.127969 12.4652 -0.0978438 11.708 0.390319 11.2293C0.878482 10.7505 1.6505 10.7209 2.1742 11.1399L2.27577 11.2293L7.99982 16.8432L21.724 3.38302Z" fill="currentcolor"/></g></svg>
            </span>
          </div>
          <div class="rewards-tiers-labels-item">
            <span class="intensive_item"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="M16.8482 0.982867C17.4745 0.563804 18.2507 0.66271 18.6393 1.00068C18.8076 1.1474 18.9721 1.39724 18.7987 1.75537C18.4345 2.51099 17.6587 2.99896 16.8234 2.99896H14.4318C14.5443 3.28959 14.6066 3.60505 14.6066 3.93505C14.6066 4.22896 14.557 4.51162 14.467 4.77552H20.0915C20.4665 4.06302 20.4937 3.24505 20.1595 2.49552L19.4741 0.957085C19.394 0.77896 19.2712 0.613023 19.1043 0.46771C18.5221 -0.0376022 17.3971 -0.234477 16.4549 0.395523L13.8721 2.12474C14.0362 2.29443 14.1777 2.48568 14.2912 2.69427L16.8482 0.982867ZM9.53477 4.77505C9.4423 4.50449 9.3951 4.22052 9.39508 3.93459C9.39508 3.60459 9.45742 3.28912 9.56992 2.99849H7.17977C6.34445 2.99849 5.56867 2.51005 5.20258 1.75443C5.02914 1.39677 5.19367 1.14693 5.36242 1.00068C5.57148 0.818804 5.89258 0.706304 6.24227 0.706304C6.54274 0.706304 6.86383 0.789273 7.15305 0.982867L9.70961 2.69427C9.82305 2.48521 9.96508 2.29396 10.1287 2.12474L7.54586 0.395523C6.60367 -0.234477 5.47867 -0.0376022 4.89789 0.46771C4.7118 0.629429 4.57961 0.81646 4.5018 1.01802L3.84227 2.49505C3.50758 3.24459 3.53477 4.06255 3.91023 4.77505H9.53477ZM10.2974 4.77505H13.7029C13.8285 4.52146 13.8998 4.23599 13.8998 3.93459C13.8998 2.88787 13.0466 2.03474 11.9999 2.03474C10.9532 2.03474 10.1001 2.88787 10.1001 3.93459C10.1005 4.23646 10.1718 4.52146 10.2974 4.77505ZM0.759766 6.96787V9.29052C0.759766 9.98849 1.24352 10.5754 1.89273 10.7343H10.6907V5.48099H2.24617C1.4268 5.48099 0.759766 6.14802 0.759766 6.96787ZM1.8932 22.0269C1.8932 23.1149 2.7782 23.9999 3.86617 23.9999H10.6912V11.4397H1.8932V22.0269ZM21.7546 5.48099H13.311V10.7338H22.1076C22.7573 10.5749 23.2405 9.98802 23.2405 9.29005V6.9674C23.241 6.14802 22.574 5.48099 21.7546 5.48099ZM13.311 23.9999H20.1346C21.2226 23.9999 22.1076 23.1149 22.1076 22.0269V11.4397H13.311V23.9999Z"></path></g></svg> ${window.PXUTheme.translation.intensive} ${intensiveSize}</span>
            <span class="rewards-tiers-labels-item-label">${window.PXUTheme.translation.from} ${toDeDecimal(tier.label)}</span>
          </div>
        </div>
      `;
        tiersContainer.append(dot);
      });
    } catch (e) {
      console.error(e);
    }
  }

  function toDeDecimal(label) {
    // matches a number like "37.42" or "69.9" inside the label string
    return label.replace(/\d+(\.\d+)?/, (match) => {
      return parseFloat(match).toFixed(2).replace('.', ',');
    });
  }

  function renderCrossSellProductElement(crossSellProducts) {
    const crossSellContainers = document.querySelectorAll(".cross-sell-products-container");
    if (crossSellContainers.length > 0) {
      const productWrapper = document.createElement("div");
      productWrapper.classList.add("cross-sell-product-wrapper");
      const sliderContainer = document.createElement("div");
      sliderContainer.classList.add("cross-sell-slider");

      crossSellProducts.forEach((product) => {
        const sliderElement = document.createElement("div");
        sliderElement.classList.add("slick_slide");
        const productElement = document.createElement("div");
        productElement.classList.add("cross-sell-product");

        productElement.innerHTML = `
        <img src="${product.image}" alt="${product.title}" class="cross-sell-product-image">
        <div class="cross-sell-product_content">
          <h4 class="cross-sell-product-title">${product.title}</h4>
          <div class="cross-sell-price-with-cta">
            <p class="cross-sell-product-price">${product.price}</p>
          </div>
        </div>
        <div class="cross-sell-cta">
          <button class="add-to-cart-cross-sell-button" data-variant-id="${product.variantId}">${window.PXUTheme.translation.add}</button>
        </div>`;
        sliderElement.appendChild(productElement);
        sliderContainer.appendChild(sliderElement);
      });

      productWrapper.appendChild(sliderContainer);
      crossSellContainers.forEach((container) => {
        container.appendChild(productWrapper.cloneNode(true));
      });

      initOrReinitCrossSellSliders();

      const addToCartCrossSellButtons = document.querySelectorAll(".add-to-cart-cross-sell-button");
      addToCartCrossSellButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
          e.preventDefault();
          const productVariantId = e.target.getAttribute("data-variant-id");
          if (productVariantId) {
            addToCartCrossSell(productVariantId);
          }
        });
      });
    }
  }

  function initOrReinitCrossSellSliders() {
    const $sliders = jQuery(".cross-sell-slider");
    $sliders.each(function () {
      const $slider = jQuery(this);
      if (typeof jQuery.fn.slick !== "function") return;
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }
      $slider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: '<button type="button" class="slick-next">Next</button>',
      });
    });
  }

  function addToCartCrossSell(productVariantId) {
    $(".ajax_cart_content").addClass("cart-loading");
    const formData = { items: [{ id: productVariantId, quantity: 1 }] };
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then(async () => {
        await window.PXUTheme.jsAjaxCart.updateGiftProducts();
        window.PXUTheme.jsAjaxCart.updateView();
      })
      .catch(() => {
        $(".ajax_cart_content").removeClass("cart-loading");
      });
  }

  var UPSELL_SESSION_KEY = 'cart_upsell_selected_variant';

  function _findUpsellLineKey(variantId, callback) {
    var root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart.js')
      .then((r) => r.json())
      .then((cart) => {
        var vid = parseInt(variantId, 10);
        var found = null;
        cart.items.forEach((item) => {
          if (Number(item.variant_id) === vid && item.properties && item.properties['_upsell'] === '1') {
            found = item.key;
          }
        });
        callback(null, found);
      })
      .catch((err) => callback(err, null));
  }

  function _addUpsellToCart(variantId, onDone) {
    var root = window.Shopify?.routes?.root || '/';
    var vid = parseInt(variantId, 10);
    fetch(root + 'cart.js')
      .then((r) => r.json())
      .then((cart) => {
        var alreadyIn = cart.items.some((item) => Number(item.variant_id) === vid && item.properties && item.properties['_upsell'] === '1');
        if (alreadyIn) {
          sessionStorage.setItem(UPSELL_SESSION_KEY, String(variantId));
          if (onDone) onDone();
          return Promise.resolve(null);
        }
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { '_upsell': '1' } }] })
        }).then((r) => r.json());
      })
      .then(async (res) => {
        if (!res) return;
        sessionStorage.setItem(UPSELL_SESSION_KEY, String(variantId));
        await window.PXUTheme.jsAjaxCart.updateGiftProducts();
        window.PXUTheme.jsAjaxCart.updateView();
        if (onDone) onDone();
      })
      .catch((err) => {
        if (onDone) onDone(err);
      });
  }

  function _removeUpsellFromCart(variantId, onDone) {
    var root = window.Shopify?.routes?.root || '/';
    _findUpsellLineKey(variantId, function (err, lineKey) {
      if (err || !lineKey) {
        sessionStorage.removeItem(UPSELL_SESSION_KEY);
        if (onDone) onDone();
        return;
      }
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      })
        .then((r) => r.json())
        .then(async () => {
          sessionStorage.removeItem(UPSELL_SESSION_KEY);
          await window.PXUTheme.jsAjaxCart.updateGiftProducts();
          window.PXUTheme.jsAjaxCart.updateView();
          if (onDone) onDone();
        })
        .catch((err) => {
          if (onDone) onDone(err);
        });
    });
  }

  function _syncUpsellStateWithCart(variantId, checkbox, card, subtitleEl, subtitleOn, subtitleOff) {
    var root = window.Shopify?.routes?.root || '/';
    var stored = sessionStorage.getItem(UPSELL_SESSION_KEY);
    /*if (!stored || stored !== String(variantId)) {
      checkbox.checked = false;
      card.classList.remove('is-checked');
      if (subtitleEl) subtitleEl.textContent = subtitleOff;
      return;
    }*/
    fetch(root + 'cart.js')
      .then((r) => r.json())
      .then((cart) => {
        var vid = parseInt(variantId, 10);
        var inCart = cart.items.some((item) => Number(item.variant_id) === vid && item.properties && item.properties['_upsell'] === '1');
        if (inCart) {
          checkbox.checked = true;
          card.classList.add('is-checked');
          if (subtitleEl) subtitleEl.textContent = subtitleOn;
        } else {
          sessionStorage.removeItem(UPSELL_SESSION_KEY);
          checkbox.checked = false;
          card.classList.remove('is-checked');
          if (subtitleEl) subtitleEl.textContent = subtitleOff;
        }
      });
  }

  function initUpsellCheckbox() {
    var blocks = document.querySelectorAll('.cart-upsell-block');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var variantId = block.getAttribute('data-upsell-variant-id');
      var subtitleOn = block.getAttribute('data-subtitle-checked');
      var subtitleOff = block.getAttribute('data-subtitle-unchecked');
      var checkbox = block.querySelector('.cart-upsell-checkbox');
      var card = block.querySelector('.cart-upsell-card');
      var subtitleEl = block.querySelector('.cart-upsell-subtitle');

      if (!checkbox || !variantId) return;

      _syncUpsellStateWithCart(variantId, checkbox, card, subtitleEl, subtitleOn, subtitleOff);
    });

    // FIXED: Global Document Event Delegation setup
    // This catches checkbox toggle events perfectly, even after asynchronous cart re-renders
    if (window._cartUpsellDelegated) return;
    window._cartUpsellDelegated = true;

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target || !target.classList.contains('cart-upsell-checkbox')) return;

      var block = target.closest('.cart-upsell-block');
      if (!block) return;

      var variantId = block.getAttribute('data-upsell-variant-id');
      var subtitleOn = block.getAttribute('data-subtitle-checked');
      var subtitleOff = block.getAttribute('data-subtitle-unchecked');
      var card = block.querySelector('.cart-upsell-card');
      var subtitleEl = block.querySelector('.cart-upsell-subtitle');

      if (!variantId) return;

      $(".ajax_cart_content").addClass("cart-loading");
      target.disabled = true;

      if (target.checked) {
        if (card) card.classList.add('is-checked');
        if (subtitleEl) subtitleEl.textContent = subtitleOn;
        _addUpsellToCart(variantId, function (err) {
          target.disabled = false;
          if (err) {
            target.checked = false;
            if (card) card.classList.remove('is-checked');
            if (subtitleEl) subtitleEl.textContent = subtitleOff;
            $(".ajax_cart_content").removeClass("cart-loading");
          }
        });
      } else {
        if (card) card.classList.remove('is-checked');
        if (subtitleEl) subtitleEl.textContent = subtitleOff;
        _removeUpsellFromCart(variantId, function (err) {
          target.disabled = false;
          if (err) {
            target.checked = true;
            if (card) card.classList.add('is-checked');
            if (subtitleEl) subtitleEl.textContent = subtitleOn;
            $(".ajax_cart_content").removeClass("cart-loading");
          }
        });
      }
    });
  }
})();

/*****/
(function () {
  const CLASS_TARGETS = [
    '.theme-ajax-cart',
    '.ajax_cart_content',
    '.ajax-cart__details-wrapper'
  ];

  function getScrollEl() {
    const els = document.querySelectorAll('.product_with_cross_sell_block');
    // Pick last one — index 1 is always the visible drawer
    return els[els.length - 1] || null;
  }

  function attachScrollListener() {
    const scrollEl = getScrollEl();
    if (!scrollEl || scrollEl._scrollListenerAttached) return;
    if (scrollEl.offsetHeight === 0) return;

    scrollEl._scrollListenerAttached = true;

    scrollEl.addEventListener('scroll', function () {
      const atBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 2;

      CLASS_TARGETS.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (el.offsetHeight > 0) {
            el.classList.toggle('last_touch', atBottom);
          }
        });
      });

      console.log(atBottom ? '✅ BOTTOM — last_touch added' : '❌ UP — last_touch removed');
    });

    console.log('✅ Attached | scrollH:', scrollEl.scrollHeight, '| clientH:', scrollEl.clientHeight);
  }

  // Watch drawer open
  document.addEventListener('DOMContentLoaded', function () {
    const drawers = document.querySelectorAll('[data-ajax-cart-drawer]');
    const drawerEl = drawers[drawers.length - 1] || document.querySelector('[data-ajax-cart-drawer]');

    if (drawerEl) {
      new MutationObserver(function () {
        if (drawerEl.classList.contains('is-visible')) {
          setTimeout(attachScrollListener, 400);
        }
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }

    setTimeout(attachScrollListener, 400);
  });
})();